// src/pages/PrivacyPage.js
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function PrivacyPage() {
  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ paddingTop: 32, paddingBottom: 60 }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: 4 }}>Privacy Policy</h1>
        <p style={{ color: 'var(--muted)', fontSize: '0.82rem', marginBottom: 24 }}>Last updated: March 2026</p>

        <div className="card" style={{ fontSize: '0.84rem', lineHeight: 1.7, color: 'var(--text)' }}>
          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>1. Information We Collect</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            <strong>Account data:</strong> name, email address, and authentication credentials (via Firebase Auth
            or Google OAuth).<br />
            <strong>Agreement data:</strong> titles, details, participant names, amounts, deadlines, and status.<br />
            <strong>Evidence files:</strong> photos, screenshots, and PDFs you upload.<br />
            <strong>Usage data:</strong> basic analytics including page views and feature usage.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>2. How We Use Your Data</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            We use your data to provide and improve the TuttoClaro service, including creating and managing
            agreements, authenticating users, processing payments, and sending verification emails. We do not
            sell your personal data to third parties.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>3. Data Storage</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            Your data is stored on Google Cloud infrastructure via Firebase services:<br />
            <strong>Firestore</strong> for agreement and user data<br />
            <strong>Cloud Storage</strong> for evidence files<br />
            <strong>Firebase Auth</strong> for authentication<br />
            Data is stored in the United States. All data is encrypted in transit (TLS) and at rest.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>4. Data Sharing</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            Agreement data is shared with the participants you designate when you create or share an agreement.
            Anyone with a valid agreement link can view that agreement's details. We use the following
            third-party services: Firebase (Google), Stripe (payments), and Anthropic (AI features for
            premium users only — images are processed but not stored by Anthropic).
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>5. Your Rights</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            You may access, update, or delete your account data at any time. To request full data deletion,
            contact us at support@tuttoclaro.com. We will process deletion requests within 30 days.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>6. Cookies</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            We use essential cookies for authentication and session management. We do not use advertising
            or tracking cookies.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>7. Changes</h3>
          <p style={{ color: 'var(--muted)' }}>
            We may update this policy as needed. Material changes will be communicated via email or
            in-app notification.
          </p>
        </div>

        <p style={{ textAlign: 'center', fontSize: '0.78rem', color: 'var(--muted)', marginTop: 16 }}>
          Questions? Contact us at support@tuttoclaro.com
        </p>
        <Link to="/" className="btn btn-secondary" style={{ marginTop: 8 }}>Back to Home</Link>
      </div>
    </div>
  );
}
